import { AppNavMenu, AppRoute } from 'src/pages';
import { ReferralList } from './list';
import { MailOutlined } from '@ant-design/icons';
import { ReferralDetailsRoute } from './details';

export const referralRoutes: AppRoute[] = [
  {
    path: '/referrals',
    element: <ReferralList />,
  },
  {
    path: '/referrals/:referralId',
    element: <ReferralDetailsRoute />,
  },
];

export const referralNavMenus: AppNavMenu[] = [
  {
    path: '/referrals',
    title: 'Inbox',
    icon: <MailOutlined />,
  },
];
